<template>
  <ul class="notification-bell menuWithSubMenu" ref="bellContainer">
    <li>
      <button class="bell-toggle button borderless" @click="toggleDropdown" :title="bellTitle">
        <IconBell stroke="1.25" size="20" color="white" />
        <span class="badge" v-if="badgeTotal > 0">{{ badgeTotal > 99 ? '99+' : badgeTotal }}</span>
      </button>
      <ul v-bind:class="{ toggled: showDropdown }" class="subMenu notificationMenu">
        <li class="menu-header">
          <span>A precisar de atenção</span>
        </li>
        <li v-for="category in pendingCategories" :key="category.key" class="notification-item">
          <router-link
            :to="{ name: category.routeName, query: category.routeQuery }"
            @click="showDropdown = false"
          >
            <span class="count">{{ category.total }}</span>
            <span class="label">{{
              category.total === 1 ? category.singular : category.plural
            }}</span>
          </router-link>
        </li>
        <li v-if="pendingCategories.length === 0" class="no-notifications">
          Nada a precisar de atenção.
        </li>
        <li class="menu-footer">
          <router-link :to="{ name: 'notificationPreferences' }" @click="showDropdown = false">
            Preferências
          </router-link>
        </li>
      </ul>
    </li>
  </ul>
</template>

<script>
import { mapGetters } from 'vuex'
import { IconBell } from '@tabler/icons-vue'

export default {
  name: 'NotificationBell',
  components: { IconBell },
  data() {
    return {
      showDropdown: false,
    }
  },
  computed: {
    ...mapGetters({
      pendingCategories: 'actionableCounts/pendingCategories',
      badgeTotal: 'actionableCounts/badgeTotal',
    }),
    bellTitle() {
      if (this.badgeTotal === 0) return 'Nada a precisar de atenção'
      return `${this.badgeTotal} a precisar de atenção`
    },
  },
  methods: {
    toggleDropdown() {
      this.showDropdown = !this.showDropdown
      if (this.showDropdown) {
        this.$store.dispatch('menuItem/setActive', 'notifications')
        // Reconcile the counts when the user opens the dropdown.
        this.$store.dispatch('actionableCounts/refresh')
      }
    },
    handleClickOutside(event) {
      if (this.$refs.bellContainer && !this.$refs.bellContainer.contains(event.target)) {
        this.showDropdown = false
      }
    },
  },
  watch: {
    '$store.state.menuItem.active'(v) {
      if (v !== 'notifications') {
        this.showDropdown = false
      }
    },
  },
  mounted() {
    document.addEventListener('click', this.handleClickOutside)
  },
  unmounted() {
    document.removeEventListener('click', this.handleClickOutside)
  },
}
</script>

<style lang="scss" scoped>
@use '@/scss/_variables.scss';
@use '@/scss/_navigation.scss';

.notification-bell {
  z-index: 1;
  li {
    padding: 0;
  }
}

.bell-toggle {
  position: relative;
  cursor: pointer;
  padding: 0 !important;
  min-width: 0 !important;
  min-height: 0 !important;
  margin: 0;
  display: flex;
  align-items: center;
}

.badge {
  position: absolute;
  top: -6px;
  right: -6px;
  background: var(--danger, #e53e3e);
  color: white;
  font-size: 0.6rem;
  font-weight: bold;
  padding: 1px 4px;
  border-radius: 8px;
  min-width: 14px;
  text-align: center;
  line-height: 1.2;
}

.notificationMenu {
  width: 320px;
  right: 0;
  padding: 0 !important;
  box-shadow: 3px 3px 0 var(--dark-primary) !important;
  border-left: 2px solid var(--primary);

  .menu-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: var(--sp);
    border-bottom: 1px solid var(--dark-primary);
    font-weight: 500;
    color: white;
    background: var(--slightly-darker-primary) !important;
  }

  .notification-item {
    padding: 0;
    border-bottom: 1px solid var(--dark-primary);
    background: white;

    a {
      display: flex;
      align-items: baseline;
      gap: 0.6ch;
      padding: calc(var(--sp) * 0.75) var(--sp);
      color: var(--text-color);
      width: 100%;

      &:hover {
        background: var(--dark-primary);
      }
    }

    .count {
      font-weight: 800;
      font-size: 0.95rem;
      flex-shrink: 0;
    }

    .label {
      font-weight: 300;
      font-size: 0.85rem;
    }
  }

  .no-notifications {
    padding: var(--sp);
    text-align: center;
    color: white;
    opacity: 0.7;
    font-size: 0.85rem;
  }

  .menu-footer {
    display: flex;
    justify-content: flex-end;
    padding: calc(var(--sp) * 0.75) var(--sp) !important;
    border-top: 1px solid var(--dark-primary);
    background: var(--primary) !important;
    a {
      font-size: 0.8rem;
      opacity: 0.8;
      &:hover {
        opacity: 1;
      }
    }
  }
}

@media only screen and (max-width: calc(1000px - 1px)) {
  .notificationMenu {
    width: calc(100vw - var(--sp)) !important;
    right: auto !important;
    left: 0 !important;
    position: fixed !important;
    top: 35px !important;
    max-height: calc(100vh - 35px);
    overflow-y: auto;
    li {
      line-height: 1.4;
      width: auto;
      padding-bottom: 0;
    }
  }
}
</style>
